export const applePayApiVersion = 3;
